<template>
  <div>
    <div class="page-header d-flex w-100">
      <div class="title-col d-flex w-50">
        <span class="title-icon">
          <b-icon-folder-fill></b-icon-folder-fill>
        </span>
        <span class="title-text">SOS Acknowledgement</span>
      </div>
      <!-- TODO - Undo this once acknoweledge all feature is implemented
      <div class="text-right ml-auto">
        <kendo-button class="k-button k-primary ml-2" icon="add" @click="ackAll">Acknowledge All</kendo-button>
      </div> -->
    </div>

    <div class="page-body">
      <Grid
        ref="grid"
        :style="{ height: 'auto' }"
        :data-items="items"
        :pageable="pageable"
        :page-size="pageSize"
        :skip="skip"
        :take="take"
        :total="total"
        :resizable="true"
        :selected-field="selectedField"
        :columns="columns"
        @pagechange="pageChangeHandler"
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange"
        @rowclick="onRowClick"
        @Acknowledge="Acknowledge"
      >
        <grid-toolbar>
          <div class="d-flex">
            <div class="mr-auto mobile_hide_show">
              <h5 class="mt-1"> Available Units</h5></div>
            <div class="ml-auto">
              <k-input
                v-model="search"
                placeholder="Search"
                @input="searchEnterClicked($event)"
                class="ml-2 search_mobile form-control"
              ></k-input>

              <!--<button class="k-button ml-2">Copy</button>
              <button class="k-button ml-2">Print</button>-->
            </div>
          </div>
        </grid-toolbar>
      </Grid>
    </div>
    <kendo-dialog
      ref="dialog"
      :modal="true"
      :width="300"
      :title="'Acknowledge Request'"
      :visible="false"
    >
      Are you sure that you want to proceed?
      <b-textarea
        class="mt-2"
        v-model="comment"
        placeholder="Comment"
        rows="3">
      </b-textarea>
      <kendo-dialog-action
        :text="'OK'"
        :action="okAction"
      ></kendo-dialog-action>
      <kendo-dialog-action
        :text="'Cancel'"
        :primary="true"
      ></kendo-dialog-action>
    </kendo-dialog>
  </div>
</template>
<script>
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("sosList");
import Vue from "vue";
import Acknowledge from "./Acknowledgement";
import { orderBy } from "@progress/kendo-data-query";
import { MESSAGES } from "@/utils/constants";
import { notify, notifyError } from "@/utils/notification-helper";
export default {
  data: function () {
    return {
      selectedField: "selected",
      List: [],
      dataItem: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      pageable: { pageSizes: true },
      sort: [{ field: "name", dir: "asc" }],
      search: "",
      isAll: false,
      comment: null,
      // products: products.map(item => {
      //   return { ...item, selected: false };
      // }),
    };
  },
  computed: {
    // ...mapState({
    //   List: state =>
    //     state.List.map(item => {
    //       return { ...item, selected: false };
    //     })
    // }),
    // products() {
    //   this.list.map(item => {
    //     return { ...item, selected: false };
    //   });
    // },
    areAllSelected() {
      return this.List.findIndex((item) => item.selected === false) === -1;
    },
    total() {
      return this.List ? this.List.length : 0;
    },
    items: {
      get: function () {
        return orderBy(
          this.List.filter((sl) =>
            (
              sl.vehicleRTONumber +
              "\\" +
              sl.driverName +
              "\\" +
              sl.data.dateTime +
              "\\" +
              sl.imei +
              "\\" +
              sl.lat +
              "\\" +
              sl.lng
            )
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ).slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
    columns() {
      return [
        // TODO Uncomment one acknowledgeall implemented
        // {
        //   field: "selected",
        //   width: "50px",
        //   headerSelectionValue: this.areAllSelected
        // },
        // ...this.staticColumns

        { field: "vehicleRTONumber", title: "vehicle Number",  width: "150px" },
        {
          field: "driverName",
          filter: "Driver Name",
          title: "Driver Name",
          width: "120px",
        },
        // { field: "driverMobileNumber", title: "phone Number",
        { field: "data.dateTime", title: "Date Time",  width: "100px" },
        { field: "imei", title: "IMEI",  width: "160px" },
        { field: "lat", title: "Latitude",  width: "150px" },
        { field: "lng", title: "Longitude", width: "150px" },

        { cell: Acknowledge, title: "Actions", locked: "true",  width: "150px" },
      ];
    },
  },
  // created() {
  //   this.getDataOnLoad();
  // },
  mounted() {
    this.getDataOnLoad();
  },

  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setSeclectedFacility") {
        this.getDataOnLoad();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    async getDataOnLoad() {
      this.comment = null;
      await this.$store.dispatch("sosList/list").then(() => {
        let data = this.$store.getters["sosList/List"];
        this.List = data.map((item) => {
          return { ...item, selected: false };
        });
      });
      this.$store.dispatch("fetchSosCount");
    },
    Acknowledge(e) {
      this.isAll = false;
      this.$refs.dialog.kendoWidget().open();
      this.dataItem = e;
    },
    okAction() {
      let data = [];
      if (this.isAll) {
        Vue.set(
          this,
          "List",
          this.List.map((item) => {
            data.push(item.id);
            return { ...item, selected: true };
          })
        );
      } else {
        let e = this.dataItem;
        console.log("Selected .... ", this.comment);
        data.push({ 
          Id:e.dataItem.id,
          AcknowledgeComment: this.comment 
        });
      }
      if (data.length != 0) {
        this.$store.dispatch("sosList/AckgnowlgList", data).then(() => {
          notify(MESSAGES.CHANGES_SAVE_SUCCESS);
          this.getDataOnLoad();
        });
      } else {
        notifyError("Please select items");
      }
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      // console.log("chec", checked);
      Vue.set(
        this,
        "List",
        this.List.map((item) => {
          return { ...item, selected: checked };
        })
      );
    },
    onSelectionChange(event) {
      Vue.set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
    },
    onRowClick(event) {
      Vue.set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
    },
    createRandomData() {
      return;
    },
    updatePagerState: function (key, value) {
      const newPageableState = Object.assign({}, this.pageable, {
        [key]: value,
      });
      this.pageable = newPageableState;
    },
    changeHandler: function (type, value) {
      this.updatePagerState(type, value);
    },
    ackAll() {
      this.isAll = true;
      this.$refs.dialog.kendoWidget().open();
      // let dataVal = [];
      // Vue.set(
      //   this,
      //   "List",
      //   this.List.map(item => {
      //     dataVal.push(item.id);
      //     return { ...item, selected: true };
      //   })
      // );
      // this.$store.dispatch("sosList/AckgnowlgList", dataVal).then(() => {
      //   notify(MESSAGES.CHANGES_SAVE_SUCCESS);
      //   this.getDataOnLoad();
      // });
    },
    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    searchEnterClicked() {},
    getTime: function (h, tdElement, props) {
      const field = props.field;
      var date = props.dataItem[field];
      if (!date) {
        return h("td", {}, "");
      }
      var options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };

      return h(
        "td",
        {},

        new Date(date).toLocaleString(options)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
 
@media only screen and (max-width: 768px) {
.search_mobile{width: 90% !important;}
 .mobile_hide_show{display: none;} 
}
</style>